import { getPlatform } from "@/utils/platform";
import { CenterPopup } from "antd-mobile";
import QRCode from "qrcode.react";
import React from "react";
import styles from "./index.module.scss";
const { isWxH5 } = getPlatform();

interface LiveSubscribeProps {
  subscribeLink: string;
  onSubscribePopupClose?: () => void;
}


const LiveSubscribePop: React.FC<LiveSubscribeProps> = ({ subscribeLink, onSubscribePopupClose }) => {
  return (
    <CenterPopup
      visible
      onMaskClick={onSubscribePopupClose}
      bodyStyle={{
        background: "transparent",
      }}
    >
      <div className={styles.subscribe_popup_content}>
        {subscribeLink && (
          <div
            className={styles.subscribe__wrap}
            style={{ backgroundImage: "url(https://akmer.aikucun.com/426de67fc78d916a4d2501c150e1fc45fdd50acd_1590566402971_68.png)" }}
          >
            <div className={styles.title}>订阅直播接收开播提醒</div>
            <div className={styles.subtitle}>关注公众号：店铺服务助手</div>
            <div className={`${styles.qrcode} ${isWxH5 ? styles.no_select : ""}`}>
              <QRCode value={subscribeLink} size={100} fgColor="#000000" />
            </div>
            <div className={styles.tips}>长按二维码即可关注</div>
            <div className={styles.close}>
              <i className={styles.icon_close} onClick={onSubscribePopupClose}></i>
            </div>
          </div>
        )}
      </div>
    </CenterPopup>
  );
};

export default LiveSubscribePop;
